(function () {
  'use strict';

  var instances = new WeakMap();

  function RcShopBy(root) {
    this.root = root;
    this.trigger = root.querySelector('[data-rc-shop-by-trigger]');
    this.panel = root.querySelector('[data-rc-shop-by-panel]');
    this.abortController = new AbortController();
    this.closeTimer = null;
    this.suppressFocusOpen = false;

    if (!this.trigger || !this.panel) {
      return;
    }

    this.bindEvents();
    this.resetPanels();
  }

  RcShopBy.prototype.bindEvents = function () {
    var self = this;
    var signal = this.abortController.signal;

    this.trigger.addEventListener('click', function () {
      if (self.trigger.getAttribute('aria-expanded') === 'true') {
        self.close(false);
      } else {
        self.open();
      }
    }, { signal: signal });

    this.root.addEventListener('pointerenter', function () {
      self.cancelClose();

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        self.open();
      }
    }, { signal: signal });

    this.root.addEventListener('pointerleave', function () {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        self.scheduleClose();
      }
    }, { signal: signal });

    this.root.addEventListener('focusin', function (event) {
      self.cancelClose();

      if (event.target === self.trigger && !self.suppressFocusOpen) {
        self.open();
      }

      var level2 = event.target.closest('[data-rc-shop-by-level2]');

      if (level2 && self.root.contains(level2)) {
        self.activateLevel2(level2);
      }
    }, { signal: signal });

    this.root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!self.root.contains(document.activeElement)) {
          self.close(false);
        }
      }, 0);
    }, { signal: signal });

    this.root.addEventListener('pointerover', function (event) {
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        return;
      }

      var level2 = event.target.closest('[data-rc-shop-by-level2]');

      if (level2 && self.root.contains(level2)) {
        self.activateLevel2(level2);
      }
    }, { signal: signal });

    this.root.addEventListener('click', function (event) {
      var level2 = event.target.closest('[data-rc-shop-by-level2]');

      if (level2 && self.root.contains(level2)) {
        self.activateLevel2(level2);
      }
    }, { signal: signal });

    document.addEventListener('pointerdown', function (event) {
      if (!self.root.contains(event.target)) {
        self.close(false);
      }
    }, { signal: signal });

    document.addEventListener('pointerover', function (event) {
      if (event.target.closest('[data-rc-shop-by-peer]')) {
        self.close(false);
      }
    }, { signal: signal });

    document.addEventListener('focusin', function (event) {
      if (event.target.closest('[data-rc-shop-by-peer]')) {
        self.close(false);
      }
    }, { signal: signal });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.trigger.getAttribute('aria-expanded') === 'true') {
        event.preventDefault();
        self.close(true);
      }
    }, { signal: signal });
  };

  RcShopBy.prototype.open = function () {
    var self = this;

    document.querySelectorAll('[data-rc-shop-by-root]').forEach(function (root) {
      if (root !== self.root) {
        var instance = instances.get(root);
        if (instance) {
          instance.close(false);
        }
      }
    });

    this.cancelClose();
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.root.classList.add('rc-shop-by-is-open');

    if (!this.panel.querySelector('[data-rc-shop-by-level2][aria-expanded="true"]')) {
      this.resetPanels();
    }
  };

  RcShopBy.prototype.close = function (restoreFocus) {
    if (!this.trigger || !this.panel) {
      return;
    }

    this.cancelClose();
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.root.classList.remove('rc-shop-by-is-open');

    if (restoreFocus) {
      this.suppressFocusOpen = true;
      this.trigger.focus();
      this.suppressFocusOpen = false;
    }
  };

  RcShopBy.prototype.scheduleClose = function () {
    var self = this;
    this.cancelClose();
    this.closeTimer = window.setTimeout(function () {
      self.close(false);
    }, 180);
  };

  RcShopBy.prototype.cancelClose = function () {
    if (this.closeTimer !== null) {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  };

  RcShopBy.prototype.resetPanels = function () {
    var firstLevel2 = this.panel.querySelector('[data-rc-shop-by-level2]');

    if (firstLevel2) {
      this.activateLevel2(firstLevel2);
    }
  };

  RcShopBy.prototype.activateLevel2 = function (control) {
    var branch = control.getAttribute('data-rc-shop-by-level2');
    var detail = this.panel.querySelector('[data-rc-shop-by-detail="' + branch + '"]');

    this.panel.querySelectorAll('[data-rc-shop-by-level2]').forEach(function (button) {
      button.setAttribute('aria-expanded', button === control ? 'true' : 'false');
    });
    this.panel.querySelectorAll('[data-rc-shop-by-detail]').forEach(function (item) {
      item.hidden = item !== detail;
    });

    if (!detail) {
      return;
    }
  };

  RcShopBy.prototype.destroy = function () {
    this.cancelClose();
    this.abortController.abort();
    instances.delete(this.root);
  };

  function init(scope) {
    var roots = [];

    if (scope.matches && scope.matches('[data-rc-shop-by-root]')) {
      roots.push(scope);
    }
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rc-shop-by-root]')));

    roots.forEach(function (root) {
      if (!instances.has(root)) {
        instances.set(root, new RcShopBy(root));
      }
    });
  }

  function destroy(scope) {
    var roots = [];

    if (scope.matches && scope.matches('[data-rc-shop-by-root]')) {
      roots.push(scope);
    }
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-rc-shop-by-root]')));

    roots.forEach(function (root) {
      var instance = instances.get(root);
      if (instance) {
        instance.destroy();
      }
    });
  }

  function syncMobileNavigation() {
    var template = document.querySelector('[data-rc-shop-by-mobile-nav-template]');
    var target = document.querySelector('[data-rc-shop-by-mobile-nav]');

    if (!template || !template.content || !target) {
      return;
    }

    var fragment = template.content.cloneNode(true);

    while (target.firstChild) {
      target.removeChild(target.firstChild);
    }

    target.appendChild(fragment);
    target.setAttribute('data-rc-shop-by-mobile-nav-synced', 'true');
  }

  function hasMobileNavigation(scope) {
    if (!scope || !scope.querySelector) {
      return false;
    }

    if (scope.matches && scope.matches('[data-section-type="header"], [data-section-type="sidebar-menu"]')) {
      return true;
    }

    return Boolean(scope.querySelector('[data-rc-shop-by-mobile-nav-template], [data-rc-shop-by-mobile-nav]'));
  }

  syncMobileNavigation();
  init(document);

  document.addEventListener('shopify:section:load', function (event) {
    if (hasMobileNavigation(event.target)) {
      syncMobileNavigation();
    }

    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector('[data-rc-shop-by-root]');
    var instance = root ? instances.get(root) : null;

    if (instance && window.matchMedia('(min-width: 1140px)').matches) {
      instance.open();
    }
  });
}());
